import React, { useEffect, useState } from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid,
  Autocomplete,
  Typography
} from "@mui/material"
import { Controller, useForm } from "react-hook-form"
import apiUrl from '../../configs/constant';
import axios from 'axios'
import { useToast } from "../ToastProvider";

const today = () => new Date().toISOString().split("T")[0]

interface Props {
  open: boolean
  mode: string
  data?: any
  onClose: () => void
}

export default function DialogMemo({
  open,
  mode,
  data,
  onClose
}: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();
  const [akunList, setAkunList] = useState<any[]>([])

  useEffect(() => {
    if (!open) return
    setValue('tanggal',today())
    setValue('totalInvoice',data.total)
    setValue('sisaPiutang',data.total_sisa_piutang)
    getAkun()
    console.log(data)
  }, [open])

    const {
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues,
        reset,
        watch
    } = useForm({
        defaultValues: {
            tanggal: today(),
            totalInvoice: '',
            sisaPiutang: '',
            akun: null,
            totalSesuaian: '',
            piutangAkhir: '',
            keterangan: ''
        }
    })
    
    const sisaPiutang = watch("sisaPiutang")
    const totalSesuaian = watch("totalSesuaian")

    useEffect(() => {
    const sisa = Number(sisaPiutang || 0)
    const sesuaian = Number(totalSesuaian || 0)
    const hasil = sisa - sesuaian
    setValue("piutangAkhir", formatNumber(hasil))
    }, [sisaPiutang, totalSesuaian, setValue])

    const getAkun = () => {
        let url = apiUrl.apiUrl + '/acc/laporan-keuangan/list-akun'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setAkunList(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const onSubmit = (obj: any) => {
    const payload = {
        tgl: obj.tanggal,
        sdcust_id: data.sdcust_id,
        accinv_id: data.id,
        total_invoice: String(obj.totalInvoice || "").replace(/\./g, ""),
        sisa_piutang: String(obj.sisaPiutang || "").replace(/\./g, ""),
        total_sesuaian: String(obj.totalSesuaian || "").replace(/\./g, ""),
        piutang_akhir: String(obj.piutangAkhir || "").replace(/\./g, ""),
        accakun_id: obj.akun?.id,
        sysdoctag_id : 12603000004,
        keterangan:obj.keterangan
    }
    
    const url = apiUrl.apiUrl + '/acc/invoice/save-memo'
    
    axios.post(url, payload, {
        headers: { Authorization: `Bearer ${token}` }
    }).then(res => {
        showToast(res.data.message, 'success')
        onClose()
    })
  }

    const formatNumber = (value: string | number) => {
    if (!value) return ""
    return Number(value).toLocaleString("id-ID")
    }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <form onSubmit={handleSubmit(onSubmit)}>
            <DialogTitle>
                {mode === "add" ? "Tambah Memo AR" : "Edit Memo AR"}
            </DialogTitle>

            <DialogContent dividers>

            <Grid container spacing={2}>

                {/* INFORMASI DASAR */}
                <Grid item xs={12}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                    Informasi Dasar
                </Typography>
                </Grid>

                {/* Tanggal */}
                <Grid item xs={12}>
                <Controller
                    name="tanggal"
                    control={control}
                    rules={{ required: "Tanggal wajib diisi" }}
                    render={({ field }) => (
                    <TextField
                        {...field}
                        type="date"
                        label="Tanggal Memo"
                        InputLabelProps={{ shrink: true }}
                        helperText={errors.tanggal?.message as string}
                        error={!!errors.tanggal}
                        fullWidth
                    />
                    )}
                />
                </Grid>
                {/* INFORMASI TAGIHAN */}
                <Grid item xs={12}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                    Informasi Tagihan
                </Typography>
                </Grid>

                {/* Total Invoice */}
                <Grid item xs={12}>
                <Controller
                    name="totalInvoice"
                    control={control}
                    rules={{ required: "Total invoice wajib diisi" }}
                    render={({ field }) => (
                    <TextField
                        {...field}
                        label="Total Invoice"
                        fullWidth
                        value={formatNumber(field.value || "0")}
                        inputProps={{ inputMode: "numeric",readOnly: true }}
                        onChange={(e) => field.onChange(formatNumber(e.target.value))}
                        error={!!errors.totalInvoice}
                        helperText={errors.totalInvoice?.message as string}
                    />
                    )}
                />
                </Grid>

                {/* Sisa Piutang */}
                <Grid item xs={12}>
                <Controller
                    name="sisaPiutang"
                    control={control}
                    rules={{ required: "Sisa piutang wajib diisi" }}
                    render={({ field }) => (
                    <TextField
                        {...field}
                        label="Sisa Piutang Saat Ini"
                        fullWidth
                        value={formatNumber(field.value || "0")}
                        inputProps={{ inputMode: "numeric",readOnly: true }}
                        onChange={(e) => field.onChange(formatNumber(e.target.value))}
                        error={!!errors.sisaPiutang}
                        helperText={errors.sisaPiutang?.message as string}
                    />
                    )}
                />
                </Grid>

                {/* PENYESUAIAN */}
                <Grid item xs={12}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                    Penyesuaian
                </Typography>
                </Grid>

                {/* Akun */}
                <Grid item xs={12}>
                <Controller
                    name="akun"
                    control={control}
                    rules={{ required: "Akun penyesuaian wajib dipilih" }}
                    render={({ field }) => (
                    <Autocomplete
                        {...field}
                        value={field.value || null}
                        options={akunList}
                        isOptionEqualToValue={(opt, val) => opt.id === val?.id}
                        getOptionLabel={(o) => o?.nama ?? ""}
                        onChange={(_, val) => field.onChange(val)}
                        renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Akun Penyesuaian"
                            helperText={errors.akun?.message as string}
                            error={!!errors.akun}
                        />
                        )}
                    />
                    )}
                />
                </Grid>

                {/* Total Sesuaian */}
                <Grid item xs={12}>
                    <Controller
                        name="totalSesuaian"
                        control={control}
                        rules={{ required: "Total penyesuaian wajib diisi" }}
                        render={({ field }) => (
                            <TextField
                            {...field}
                            label="Total Penyesuaian"
                            fullWidth
                            value={formatNumber(field.value || "0")}
                            inputProps={{ inputMode: "numeric" }}
                            onChange={(e) => {
                                const raw = e.target.value.replace(/\D/g, "") // hanya angka
                                field.onChange(raw)
                            }}
                            error={!!errors.totalSesuaian}
                            helperText={errors.totalSesuaian?.message as string}
                            />
                        )}
                    />
                </Grid>

                {/* HASIL */}
                <Grid item xs={12}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                    Hasil Akhir
                </Typography>
                </Grid>

                {/* Piutang Akhir */}
                <Grid item xs={12}>
                <Controller
                    name="piutangAkhir"
                    control={control}
                    render={({ field }) => (
                        <TextField
                        {...field}
                        label="Piutang Setelah Penyesuaian"
                        fullWidth
                        InputProps={{
                            readOnly: true
                        }}
                        />
                    )}
                />
                </Grid>

                {/* CATATAN */}
                <Grid item xs={12}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                    Catatan
                </Typography>
                </Grid>

                <Grid item xs={12}>
                <Controller
                    name="keterangan"
                    control={control}
                    render={({ field }) => (
                    <TextField
                        {...field}
                        label="Keterangan"
                        multiline
                        rows={3}
                        fullWidth
                    />
                    )}
                />
                </Grid>
            </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    size="large"
                >
                    SIMPAN MEMO
                </Button>
            </DialogActions>
        </form>
        </Dialog>
  )
}